import { IpList } from "@/pages/Users";

export default function IpAccess() {
  return (
    <div className="max-w-2xl space-y-5">
      <div>
        <h1 className="font-display text-4xl font-bold">Akses IP</h1>
        <p className="text-sm text-slate-500 mt-1">Kalau IP internet kantor berubah (mis. modem reset), tambahkan IP baru di sini supaya staf bisa login lagi. Semua perubahan tercatat di Riwayat Aktivitas.</p>
      </div>
      <IpList />
    </div>
  );
}
